export default __webpack_public_path__ + "static/media/CardReverb.e611796f.svg";